<template>
  <div class="app-substitute-sim-wrapper">
    <slot name="txtBefore"></slot>
    <!-- Auswahl bestellen/aktivieren -->
    <div class="substitute-sim-process overview-process" v-if="!showSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderSubstituteSimProcess">Ersatz-SIM-Karte</slot>
        <b-btn @click="changeStep({ step: processStepName })" class="accordion-toggle" v-if="editButtonProcess"><slot name="btnPrev">ändern</slot></b-btn>
      </div>
      <b-collapse v-model="openProcess">
        <div class="txt-before-process">
          <dyn-slot :slot-data="{ msisdn: this.msisdn_ }">
            <slot name="txtBeforeProcess">Deine Nr: {{ msisdn_ }}</slot>
          </dyn-slot>
        </div>
        <b-form-radio-group name="processSelection" class="rows" v-model="processSelected" >
          <b-form-radio value="order"><slot name="orderRadio">bestellen</slot></b-form-radio>
          <b-form-radio value="activate"><slot name="activationRadio">aktivieren</slot></b-form-radio>
        </b-form-radio-group>
        <b-btn @click="startProcess" variant="primary"><slot name="startProcessBtn">weiter</slot></b-btn>
      </b-collapse>
    </div>
    <!-- Sim-Bestellen-Optionen -->
    <div class="substitute-sim-options overview-process" v-if="!showSuccess && isProcessOrder">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderSubstituteSimOptions">Bestelloptionen</slot>
        <b-btn @click="changeStep({ step: optionsStepName })" class="accordion-toggle" v-if="editButtonOptions"><slot name="btnPrev">ändern</slot></b-btn>
      </div>
      <b-collapse v-model="openOptions">
        <Options :next-step="summaryStepName" v-if="openOptions" :options="substituteSimCardOptions_" :customer-balance="currentCustomer.balance">
          <template v-for="slot in possibleChildSlotsFor('Options')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Options>
      </b-collapse>
    </div>
    <!-- Success -->
    <div class="substitute-sim-success overview-process" v-if="showSuccess">
      <div class="accordion-header">
        <div v-if="isProcessActivation && !isActivated_"><slot name="txtAccordionHeaderSubstituteSimSuccessAlreadyActive">Success</slot></div>
        <div v-if="isProcessActivation && isActivated_"><slot name="txtAccordionHeaderSubstituteSimSuccessActivated">Success</slot></div>
        <div v-if="isProcessOrder"><slot name="txtAccordionHeaderSubstituteSimSuccessOrdered">Success</slot></div>
      </div>
      <b-collapse v-model="openSuccess">
        <Success v-if="openSuccess" :prevStep="processStepName" :is-activated="isActivated_" :is-process-order="isProcessOrder">
          <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Success>
      </b-collapse>
    </div>
    <!-- Zusammenfassung -->
    <div class="substitute-sim-summary overview-process" v-if="isProcessOrder">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderSubstituteSimSummarySuccess" v-if="showSuccess">Zusammenfassung</slot>
        <slot name="txtAccordionHeaderSubstituteSimSummary" v-else>Zusammenfassung</slot>
        <b-btn @click="changeStep({ step: summaryStepName })" class="accordion-toggle" v-if="editButtonSummary"><slot name="btnPrev">ändern</slot></b-btn>
      </div>
      <b-collapse v-model="openSummary">
        <Summary :nextStep="successStepName" v-if="openSummary" :current-customer="currentCustomer">
          <template v-for="slot in possibleChildSlotsFor('Summary')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Summary>
      </b-collapse>
    </div>
  </div>
</template>
<script>

import transaction from '@/mixins/transaction'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import slotProxy from '@/mixins/slotProxy'
import Options, { stepName as optionsStepName } from '@/components/process/generic/SimCard/SubstituteSimCard/fyve/Options.vue'
import Summary, { stepName as summaryStepName } from '@/components/process/generic/SimCard/SubstituteSimCard/fyve/Summary.vue'
import Success, { stepName as successStepName } from '@/components/process/generic/SimCard/SubstituteSimCard/fyve/Success.vue'
import { wrapQuery } from '../../../../../../helper/wrapGQLQuery'
import gql from 'graphql-tag'

export const processStepName = 'process'

const computedAccordionOpen = function (stepName) {
  return {
    get () {
      if (this.currentStep === 'success' && stepName === 'summary') {
        return true
      }
      return this.currentStep === stepName
    },
    set () {} // dummy setter for v-model bind
  }
}

const computedEditButton = function (stepName) {
  return {
    get () {
      return processSteps.indexOf(this.currentStep) > processSteps.indexOf(stepName)
    }
  }
}

const processSteps = [processStepName, optionsStepName, successStepName, summaryStepName]
export default {
  name: 'SubstituteSimCardWrapper',
  data () {
    return {
      processSelected: 'order',
      substituteSimCardOptions: [{
        description: '',
        name: '',
        price: '',
        productNumber: '',
        type: '',
        possibleActivationSettings: '',
        productPrice: '',
        shippingCosts: '',
        total: ''
      }],
      currentCustomer: {
        contract: {
          msisdn: ''
        },
        salutation: '',
        firstName: '',
        lastName: '',
        address: {
          city: '',
          houseNumber: '',
          street: '',
          supplement: '',
          zip: ''
        },
        balance: 0
      }
    }
  },
  mounted () {},
  import: {
    processStepName,
    optionsStepName,
    summaryStepName,
    successStepName
  },
  components: {
    Options,
    Summary,
    Success
  },
  computed: {
    ...mapGetters('substituteSimCard', [
      'currentStep'
    ]),
    ...mapGetters('substituteSimCard', [
      'isErrorAlreadyActivated'
    ]),
    isActivated_ () {
      return this.isErrorAlreadyActivated
    },
    isProcessActivation () {
      return this.processSelected === 'activate'
    },
    isProcessOrder () {
      return this.processSelected === 'order'
    },
    substituteSimCardOptions_ () {
      return [this.substituteSimCardOptions[1]] // nur das kostenpflichtige anzeigen
    },
    msisdn_ () {
      return this.currentCustomer.contract.msisdn
    },
    // open status for accordions
    openProcess: computedAccordionOpen.bind(this)(processStepName),
    openOptions: computedAccordionOpen.bind(this)(optionsStepName),
    openSummary: computedAccordionOpen.bind(this)(summaryStepName),
    openSuccess: computedAccordionOpen.bind(this)(successStepName),
    showSuccess: computedAccordionOpen.bind(this)(successStepName),
    // show edit buttons for steps
    editButtonProcess: computedEditButton.bind(this)(processStepName),
    editButtonOptions: computedEditButton.bind(this)(optionsStepName),
    editButtonSummary: computedEditButton.bind(this)(summaryStepName)
  },
  methods: {
    ...mapMutations('substituteSimCard', [
      'changeStep'
    ]),
    ...mapActions('substituteSimCard', [
      'activateSim'
    ]),
    async startProcess () {
      if (this.processSelected === 'order') {
        this.changeStep({ step: optionsStepName })
      } else if (this.processSelected === 'activate') {
        this.loading = true
        await this.activateSim({ nextStep: successStepName })
        this.loading = false
      }
    }
  },
  mixins: [
    transaction('substituteSimCard'),
    slotProxy()
  ],
  props: {},
  apollo: {
    substituteSimCardOptions: function () {
      return wrapQuery(
        gql`query simOrder {
                    substituteSimCardOptions{
                        description
                        name
                        price
                        productNumber
                        type
                        possibleActivationSettings
                        productPrice
                        shippingCosts
                        total
                    },
                }`, this, 'substituteSimCardOptions', {}, null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    },
    currentCustomer: function () {
      return wrapQuery(gql`query balanceInfo {
        currentCustomer {
          contract {
            msisdn
          },
          salutation,
            firstName,
            lastName,
            address {
              city,
              houseNumber,
              street,
              supplement,
              zip
            },
            balance
        }
      }`, this, 'currentCustomer')
    }
  }
}
</script>
